import { useMutation, useQueryClient } from "@tanstack/react-query";

import { importNationalHolidays } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import { invalidateHolidayQueries } from "./invalidate-holidays";

export function useImportHolidays() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: (year: number) =>
			importNationalHolidays(activeCanteiroId as string, year),
		onSuccess: () => invalidateHolidayQueries(queryClient),
	});
}
